import React from 'react';
import { Icon } from '@fluentui/react';
import styles from './MobileToggle.module.css';

interface MobileToggleProps {
    showResults: boolean;
    onToggle: () => void;
    resultsCount?: number;
    className?: string;
}

const MobileToggle: React.FC<MobileToggleProps> = ({ 
    showResults, 
    onToggle, 
    resultsCount = 0, 
    className = '' 
}) => {
    return (
        <button 
            className={`${styles.toggleButton} ${className}`}
            onClick={onToggle}
            type="button"
            aria-label={showResults ? 'Switch to chat' : 'View search results'}
            aria-pressed={showResults}
        >
            <Icon iconName={showResults ? 'Chat' : 'ViewList'} className={styles.toggleIcon} />
            <span className={styles.toggleLabel}>
                {showResults ? 'Chat' : 'Results'}
            </span>
            {!showResults && resultsCount > 0 && (
                <span className={styles.badge} aria-label={`${resultsCount} results found`}>
                    {resultsCount > 99 ? '99+' : resultsCount}
                </span>
            )}
        </button>
    );
};

export default MobileToggle;